import { BillDetailType, BillType } from 'types/plansales/billing';
import { CLOSETGroupsPlanType } from 'types/api/groups/closet';
import { CLOSETPaymentMethod } from 'types/groups/index';

export enum GroupDetailTab {
  OVERVIEW = 'overview',
  BILLING_HISTORY = 'billing-history',
}

export interface GroupDetailOverviewMemberColumn {
  permissionType: string;
  count: number;
}

export interface GroupDetailOverviewMember {
  groupAdmin: number;
  admin: number;
  collaborator: number;
  editor: number;
  viewer: number;
  groupOperator: number;
}

export enum GroupPlanHistoryStatus {
  RESERVED = 0,
  CANCELLED = 1,
  CURRENT = 2,
  COMPLETED = 3,
}

export interface GroupDetailOverviewPlanHistoryColumn {
  planType: CLOSETGroupsPlanType;
  paymentMethod: CLOSETPaymentMethod | null;
  orderDate: string | null;
  subscription: {
    startDate: string;
    endDate: string | null;
  };
  measurement: {
    startDate: string;
    endDate: string;
  };
  operator: string | null;
  status: GroupPlanHistoryStatus;
}

export interface BillingHistoryItemDetail {
  amount: number;
  quantity: number;
  type: BillDetailType;
  startDate: string;
  endDate: string;
}

export interface BillingHistoryItem {
  date: string;
  registeredDate: string;
  amount: number | null;
  balance: number;
  type: BillType;
  plan: CLOSETGroupsPlanType;
  previousPlan: CLOSETGroupsPlanType;
  invoiceId: string | null;
  registeredById: number;
  registeredByEmail: string;
  details: BillingHistoryItemDetail[];
}

export interface BillingHistoryResponse {
  items: BillingHistoryItem[];
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalItems: number;
  nextPage: number | null;
  isLastPage: boolean;
}
